<div class="sem-cadastral-parcel-control">
  <div class="cadastral-inputs-container">

    <!-- Katastrska občina številka input -->
    <div class="ko-input-group">
      <label class="ko-label">Številka katastrske občine:</label>
      <input
        type="text"
        class="form-control ko-input"
        [value]="katastrskaObcina || model[cadastralMunicipalityNumber] || ''"
        (input)="onKoChange($event)"
        [disabled]="readOnly || dfms?.isFormReadOnly == true"
        [maxlength]="maxLengthKo"
        placeholder="npr. 1722"
        [class.is-invalid]="isValid === false"
        [class.is-valid]="isValid === true"
        />
      </div>

      <!-- Municipality name input (readonly) -->
      <div class="municipality-name-group">
        <label class="municipality-label">Ime katastrske občine:</label>
        <div class="municipality-input-wrapper">
          <input
            type="text"
            class="form-control municipality-input"
            [value]="value || ''"
            readonly
            placeholder="Ime se bo prikazalo po vnosu pravilne številke"
            [class.has-value]="value"
            />
            @if (isLoadingName) {
              <div class="loader">
              </div>
            }
          </div>
        </div>

      </div>
    </div>